import { render } from "./CustomizeFooter.vue?vue&type=template&id=e7e9359c&scoped=true"
import script from "./CustomizeFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomizeFooter.vue?vue&type=script&setup=true&lang=js"

import "./CustomizeFooter.vue?vue&type=style&index=0&id=e7e9359c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7e9359c"],['__file',"src/components/UI/table/CustomizeFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e7e9359c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e7e9359c', __exports__)) {
    api.reload('e7e9359c', __exports__)
  }
  
  module.hot.accept("./CustomizeFooter.vue?vue&type=template&id=e7e9359c&scoped=true", () => {
    api.rerender('e7e9359c', render)
  })

}


export default __exports__